import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { PermissionService } from '../services/permission.service';
import { routes } from '../routes/routes';

export const sysAdminGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  if (!permissionService.isUserSysAdmin()) {
    router.navigate([routes.index]);
    return false;
  }

  return true;
};
